import React from 'react';

import cn from '~/Utils/cn';

export interface SkeletonLinesProps {
  /** Number of placeholder lines to render. */
  count: number;
  /** Optional per-line widths (any CSS width, e.g. '75%', '12rem'). Lines without an entry span full width. */
  widths?: string[];
  /** Classes applied to the wrapper (e.g. spacing/padding overrides). */
  className?: string;
  /** Classes applied to each line (e.g. height overrides). */
  lineClassName?: string;
}

/** Stacked animated-pulse bars — a generic loading placeholder for text/form content. */
const SkeletonLines: React.FC<SkeletonLinesProps> = ({ count, widths, className, lineClassName }) => (
  <div className={cn('flex flex-col gap-16', className)} data-testid="skeleton-lines">
    {Array.from({ length: count }, (_, index) => (
      <div
        key={index}
        className={cn('h-20 w-full animate-pulse rounded-lg bg-slate-400', lineClassName)}
        style={widths?.[index] ? { width: widths[index] } : undefined}
      />
    ))}
  </div>
);

export default SkeletonLines;
